import { jsx as _jsx } from "react/jsx-runtime";
import isArray from "lodash/isArray";
import * as S from "./TextStyle.styled";
export var TextStyle = function (_a) {
    var _b = _a.element, element = _b === void 0 ? "span" : _b, children = _a.children, _c = _a.size, size = _c === void 0 ? "default" : _c, _d = _a.variation, variation = _d === void 0 ? "default" : _d, _e = _a.style, style = _e === void 0 ? {} : _e;
    return (_jsx(S.TextStyle, { as: element, variations: isArray(variation) ? variation : [variation], size: size, style: style, children: children }));
};
